import { HASHTAGS } from "../../../type/EnumHashtags";
import { BRAND } from "../../../type/EnumBrand";
import { IProductData } from "../../../type/IProductData";

export const quagPowergrid2: IProductData = {
  id: "quag-powergrid-2",
  name: "Quagliardi Powergrid 2",
  description: "2 Slot 500 series chassis.",
  images: ["/img/quag_powergrid_2_front.jpg", "/img/quag_powergrid_2_back.jpg"],
  details: [{
    label: "Description",
    markdown: `
The POWERGRID 2 is a 2-slot chassis for series 500 equipment. It comes with an external linear power supply with a capacity of up to 300mA of current per voltage rail.
On its rear panel, the POWERGRID 2 features two inputs and outputs accessible via XLR connectors.
`
  }, {
    label: "Specifications",
    markdown: `
- Voltages: +/-16VDC and +48VDC for phantom power
- Max Current: 380mA total on +/-16VDC rails and 100mA on +48VDC
- Input Voltage: 100-240VAC, 50/60Hz, 120 Watts
- Weight: 1.3lb (chassis) / 0.2lb (psu)
- Dimensions: 7.1 x 3.5 x 5.3 in
`
  }, {
    label: "Manufacturer Links",
    markdown: `
- <a to="https://quagliardiaudio.com/500-series-chassis/" target="_blank">https://quagliardiaudio.com/500-series-chassis/</a>
- <a to="https://drive.google.com/file/d/1qd5zPnWJQqzIY6zAgQubjE6F909Foau0/view" target="_blank">Manual</a>
    `
  }],
  metadata: {
    hashtags: [HASHTAGS.CASES, HASHTAGS.RECORDING, HASHTAGS.MASTERING, HASHTAGS.MIXING],
    manufacturer: BRAND.QUAGLIARDI,
  }
}